<template lang="">
  <v-data-table
    mobile-breakpoint="0"
    :options.sync="headFeeTableOptions"
    :server-items-length="totalItems"
    :items-per-page="10"
    :item-key="$route.path"
    :headers="headers"
    :items="headFees"
    :loading="loading"
    loading-text="Đang Tải"
    :footer-props="footerTable"
    sort-by="title"
    @input="$emit('update:selected', $event)"
  >
    <template v-slot:v-data-table-header>
      <div class="px-10"></div>
    </template>
    <template v-slot:no-data>
      <div class="my-16 font-weight-bold">
        <p>Hiện tại chưa có {{ titleType }} trong danh sách.</p>
        <p>Vui lòng thực hiện thao tác thêm {{ titleType }} ở phía trên.</p>
      </div>
    </template>
    <template v-slot:item.title="{ item }">
      <div class="text-truncate" style="max-width: 470px">
        <router-link :to="{ path: `${$route.path}/${item.id}` }" class="text-decoration-none">{{
          item.title
        }}</router-link>
      </div>
    </template>
    <template v-slot:item.rank="{ item }">
      <div class="text-truncate" style="max-width: 470px">
        {{ item.rank }}
      </div>
    </template>
    <template v-slot:item.category="{ item }">
      <div class="text-truncate" style="max-width: 470px">
        {{ item.category == 'default' ? 'Mặc định' : item.category == 'custom' ? 'Bổ sung' : '' }}
      </div>
    </template>
    <template v-slot:item.note="{ item }">
      <v-tooltip max-width="200px" color="grey darken-1" bottom>
        <template v-slot:activator="{ on, attrs }">
          <p v-bind="attrs" v-on="on" class="nowrap ma-0">{{ item.note }}</p>
        </template>
        <span class="tooltip white--text">{{ item.note }}</span>
      </v-tooltip>
    </template>
    <template v-slot:item.action="{ item }" class="text-center">
      <v-btn icon>
        <router-link :to="{ path: `/${$route.name}/${item.id}` }" class="text-decoration-none"
          ><v-icon center color="grey darken-1">mdi-eye</v-icon></router-link
        >
      </v-btn>
    </template>
    <template v-slot:item.kind="{ item }">
      {{ item.kind | getHeadfeeKind }}
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { headerTableFee } from '@/modules/tuitionFee/head-fee/helper/headerHelper'
export default {
  data() {
    return {
      headFeeTableOptions: {},
    }
  },
  created() {
    this.clean()
  },
  computed: {
    ...mapState('tuitonFeeHeadFee', ['headFees', 'pageText', 'totalItems', 'loading', 'router', 'isSubFee']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số khoản giảm trừ mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText,
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
    headers() {
      return headerTableFee(this.router, this.isSubFee)
    },
    titleType() {
      return this.$route.meta.title
    },
  },
  methods: {
    ...mapActions('tuitonFeeHeadFee', ['requestPageSettings', 'clean', 'setSearchParam', 'setRouter']),
  },
  watch: {
    headFeeTableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage,
            type: this.router,
            isSubFee: this.isSubFee,
          })
        }
      },
      deep: true,
    },
    isSubFee() {
      this.requestPageSettings({
        page: this.headFeeTableOptions.page,
        itemsPerPage: this.headFeeTableOptions.itemsPerPage,
        type: this.router,
        isSubFee: this.isSubFee,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.v-data-table table thead tr th:first-child,
.v-data-table table tbody tr td:first-child {
  padding-left: 24px;
}

.nowrap {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: 190px;
}
.tooltip {
  word-wrap: break-word;
}
</style>
